import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { Autocomplete, TextField } from '@mui/material'

const AgentsUsed = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <Autocomplete
      value={moduleValues?.['Agents Used'] ?? []}
      multiple
      freeSolo
      options={[
        'Midazolam',
        'Diazepam',
        'Lorazepam',
        'Ketamine',
        'Propofol',
        'Fentanyl',
        'Morphine',
        'Alfentanil',
        'Remifentanil',
        'Nitrous Oxide',
        'Entonox',
        'Dexmedetomidine',
        'Clonidine',
      ]}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label="Agents Used"
          helperText="Ensure all Administrations are recorded in the 'Medicines' tab also"
        />
      )}
      onChange={(e, newValue) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Agents Used']: newValue,
        }))
      }
    />
  </Grid>
)

export default AgentsUsed
